import React, { ReactElement } from 'react';
import SliderArrowInterface from './interface/slider-arrow';

const FANextArrow: React.FC<SliderArrowInterface> = (props): ReactElement => {
  const { onClick, className } = props;

  return (
    // Added onKeyDown event to satisfy linter
    <button
      className={`${className} slick-fa`}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.code === 'enter') {
          return onClick;
        }

        return null;
      }}
    >
      <i className="fa fa-solid fa-chevron-right" />
    </button>
  );
};

export default FANextArrow;
